window.$ = window.jQuery = require('jquery');
require('./web_function')

import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper'

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.Autoplay = Autoplay;
window.Thumbs = Thumbs;

import fullpage from 'fullpage.js/dist/fullpage.extensions.min';
window.fullpage = fullpage;